"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.connectionsTableConf = void 0;
var FooterCounterWithWord_1 = __importDefault(require("containers/TableMaker/components/FooterCounterWithWord"));
var constants_1 = require("containers/TableMaker/constants");
var populatedDerived_1 = require("utils/selectors/populatedDerived");
var ConnectedOn_1 = __importDefault(require("./ConnectedOn"));
var XL = constants_1.CellSize.XL; // XL, LG, MD, SM, XS,
exports.connectionsTableConf = {
    headersMap: {
        name: 'Organisation',
        'customer.name': 'Customer',
        connectedOn: 'Connected',
    },
    config: {
        selector: populatedDerived_1.selectPopRechargedOrganizationsWithRecharges,
        defaultSort: { key: 'name', order: 1 },
    },
    row: { hoverable: true },
    cells: [
        {
            cell: { width: XL, growCell: true, offset: 'right' },
            field: 'name',
            truncate: {},
            footerAggregate: 'count',
            footerAggregateRenderValue: (0, FooterCounterWithWord_1.default)('organisation'),
        },
        {
            cell: { width: XL, growCell: true }, field: 'customer.name', truncate: {},
        },
        {
            cell: { width: XL, textAlign: 'right' },
            field: 'connectedOn',
            renderComponent: ConnectedOn_1.default,
            footerAggregate: 'countNonEmpty',
            footerAggregateRenderValue: (0, FooterCounterWithWord_1.default)('connection'),
        },
        { key: 'empty1', cell: { width: 8 } },
    ],
};
